import { Spin } from 'antd';
import styled from 'styled-components';

export const Spinner = styled(Spin)``;
